import React from "react";
import PropTypes from "prop-types";
import styles from "./Tablist.module.css";
import classnames from "classnames";

const Tablist = ({ items, activeItem, onChange, className, style }) => {
  let tabs = items.map(item => {
    const tabClass = item === activeItem ? styles.active : styles.tab;
    return (
      <li
        key={item}
        data-tab-key={item}
        className={`tab ${tabClass}`}
        onClick={() => onChange(item)}
        id={`${item}-button`}
      >
        {item}
      </li>
    );
  });

  return (
    <ul className={classnames(className, styles.list)} style={style}>
      {tabs}
    </ul>
  );
};

Tablist.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeItem: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

Tablist.defaultProps = {
  activeItem: "In Progress"
};

export default Tablist;
